<style lang="less">
  // @import '../flow.less';
  @import '../flow/base.less';
</style>
<template>
    <Tabs v-model="defaultIndex" @on-click="handleTabClick">
        <TabPane label="Disk" name="Disk">
          <DiskList ref="Disk"/>
        </TabPane>
        <TabPane label="Lun" name="Lun">
          <LunList ref="Lun"/>
        </TabPane>
    </Tabs>
</template>
<script>
import DiskList from './DiskList'
import LunList from './LunList'
export default {
  name: 'EmcMain',
  components: {
    DiskList,
    LunList
  },
  data () {
    return {
      data: {},
      defaultIndex: 'Disk'
    }
  },
  watch: {
  },
  methods: {
    handleTabClick (value) {
      if (value === 'Disk') {
        // this.$refs.Disk.getDiskList()
      } else if (value === 'Lun') {
      } else if (value === '') {
      } else if (value === '') {
      }
    }
  },
  mounted: function () {
    this.$refs.Disk.getDiskList()
  }
}
</script>
